import { ChevronRight } from '@interhyp/platform-icons';
import classNames from 'classnames';
import React, { forwardRef, useCallback, useEffect, useState } from 'react';
import { BreadcrumbItem } from "./components/BreadcrumbItem.js";
import { defaultWrapper } from "./components/DefaultBreadcrumbItemWrapper.js";
import { IconRenderer } from "../../helper/components/IconRenderer.js";
import { useOverflowBreadcrumbItems } from "../../hooks/useOverflowBreadcrumbItems.js";
import { ContextMenu } from "../contextMenu/index.js";
import styles from "./Breadcrumbs.module.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const Breadcrumbs = /*#__PURE__*/forwardRef(({
  breadcrumbs,
  className,
  wrapperComponent,
  activeBreadcrumb
}, ref) => {
  const {
    containerRef,
    visibleItems,
    hasOverflow
  } = useOverflowBreadcrumbItems(breadcrumbs);
  const [selectedItem, setSelectedItem] = useState(activeBreadcrumb ?? breadcrumbs[breadcrumbs.length - 1]?.href);
  const handleSelect = item => {
    if (!item) {
      return;
    }
    setSelectedItem(item.key);
  };
  const menuItems = breadcrumbs.map(item => ({
    key: item.href,
    label: item.label
  }));
  const WrapperComponent = wrapperComponent ?? defaultWrapper;
  const optionWrapper = useCallback(({
    children,
    option
  }) => /*#__PURE__*/_jsx(WrapperComponent, {
    to: option.key,
    className: styles.breadcrumbWrapper,
    children: children
  }), [WrapperComponent]);
  useEffect(() => {
    if (activeBreadcrumb) {
      setSelectedItem(activeBreadcrumb);
    }
  }, [activeBreadcrumb]);
  return /*#__PURE__*/_jsx("div", {
    className: classNames(styles.breadcrumbs, className),
    children: /*#__PURE__*/_jsxs("div", {
      ref: containerRef,
      className: styles.breadcrumbsRow,
      children: [hasOverflow && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ContextMenu, {
          label: "",
          items: menuItems,
          onSelect: handleSelect,
          selectedItem: selectedItem,
          externalSearch: true,
          optionWrapper: optionWrapper,
          className: styles.contextMenu,
          children: props => /*#__PURE__*/_jsxs("div", {
            className: styles.ellipsis,
            ...props(),
            children: [/*#__PURE__*/_jsx(IconRenderer, {
              icon: breadcrumbs[0].icon,
              className: styles.ellipsisIcon,
              size: "SMALL"
            }), /*#__PURE__*/_jsx("span", {
              children: "..."
            })]
          })
        }), /*#__PURE__*/_jsx(ChevronRight, {
          className: styles.forwardIcon
        })]
      }), visibleItems.map((breadcrumb, index) => /*#__PURE__*/_jsxs("div", {
        className: styles.breadcrumb,
        onClick: () => {
          setSelectedItem(breadcrumb.href);
        },
        children: [/*#__PURE__*/_jsx(BreadcrumbItem, {
          breadcrumb: breadcrumb,
          wrapperComponent: wrapperComponent
          // When the 'activeBreadcrumb' prop is provided, the active flag is based on selectedItem.
          // Otherwise, the last item from the 'breadcrumbs' array will be marked as active
          ,
          active: activeBreadcrumb ? selectedItem === breadcrumb.href : breadcrumb.href === breadcrumbs[breadcrumbs.length - 1]?.href
        }), index < visibleItems.length - 1 && /*#__PURE__*/_jsx(ChevronRight, {
          className: styles.forwardIcon
        })]
      }, breadcrumb.href))]
    })
  });
});